import request from "@/util/request";

export default {
  /**
   * 投递前预检查
   * @param params
   */
  prepareCheckout: function(categoryTimeId) {
    return request({
      url: "/user/summer/apply/prepareCheckout",
      method: "get",
      params: {
        categoryTimeId: categoryTimeId
      }
    });
  },

  /**
   * 新增投递
   * @param params
   */
  save: function(categoryTimeId) {
    return request({
      url: "/user/summer/apply/save",
      method: "post",
      params: {
        categoryTimeId: categoryTimeId
      }
    });
  }


};
